import React from 'react';

function ContactForm({ subheading, heading, paragraph, label, link }) {
    return (
        
        <div className="font-faktum flex justify-center items-center mx-auto px-[20px] bg-white py-[96px]">
            <div className="max-w-[1240px] w-full">
                <div className="max-w-[668px] mx-auto text-center w-full">
                    <h3 className="text-[16px] text-[#626262] font-medium">
                        {subheading}
                    </h3>

                    <h2 className="font-semibold text-[40px] md:text-[64px] text-[#1D1D1D] mt-[16px] capitalize">
                        {heading}
                    </h2>

                    <p className="text-[16px] text-[#626262] mt-[24px] mb-[40px]">
                        {paragraph}
                    </p>

                    <a
                        href={link}
                        title={label}
                        className="text-white text-[16px] font-semibold leading-[20px] bg-[#1D1D1D] text-center max-w-[406px] w-full block mx-auto rounded-[5px] py-[12px] px-[24px]"
                    >
                        {label}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
